import styled from 'styled-components';

export const StyledLabelWrapper = styled.span`
    width: 100%;
    display: flex;
    gap: 6px;
    align-items: center;
`;
